import React, { useState, useEffect, useRef } from 'react';
import { Avatar, IconButton, Box } from '@mui/material';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import useUserStore from '../store/UserStore';
import { uploadProfileImage } from '../services/uploadProfileImage';

export const ImageUploader = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const user = useUserStore((state) => state.user);
  const userImage = localStorage.getItem('userImage');
  const imageInputRef = useRef(null);

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Renombrar el archivo antes de enviarlo
      const renamedFile = new File([file], `${user.idpersona}.png`, { type: file.type });
      setSelectedImage(URL.createObjectURL(renamedFile));
      uploadImage(renamedFile);
    }
  };

  const openCameraDialog = async () => {
    // Ejecutar click sobre el input file usando ref
    imageInputRef.current.click();
  };

  const uploadImage = (file) => {
    const formData = new FormData();
    formData.append('idpersona', user.idpersona);
    formData.append('profileImage', file);

    uploadProfileImage(formData);

    // Liberar la URL del objeto
    const imageUrl = URL.createObjectURL(file);

    localStorage.setItem('userImage', imageUrl);
  };

  return (
    <Box sx={{ position: 'relative', display: 'inline-block' }}>
      <Avatar
        src={selectedImage ? selectedImage : userImage}
        sx={{
          width: 120,
          height: 120,
          border: '4px solid white',
          boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.15)',
        }}
      />
      <IconButton
        component="label"
        sx={{
          position: 'absolute',
          bottom: 0,
          right: 0,
          backgroundColor: '#50A579',
          color: 'white',
          borderRadius: '50%',
          border: '2px solid white',
          width: 40,
          height: 40,
          '&:hover': {
            backgroundColor: 'darkgreen',
          },
        }}
        onClick={openCameraDialog}
      >
        <PhotoCamera />
      </IconButton>

      <input
        type="file"
        accept="image/*"
        onChange={handleImageChange}
        ref={imageInputRef}
        hidden
      />
    </Box>
  );
};
